import { AlertCircle, CheckCircle, XCircle } from "react-feather";

export const MESSAGE = [
  {
    bgColor: "primary",
    icon: <CheckCircle />,
    title: "Helen Walter",
    para: "Hi , Helen",
    time: "10 min.",
  },
  {
    bgColor: "secondary",
    icon: <AlertCircle />,
    title: "Vincent Porter",
    para: "Change for anyone.",
    time: "35 min.",
  },
  {
    bgColor: "success",
    icon: <XCircle />,
    title: "Helen Walter",
    para: "Hello Name",
    time: "50 min.",
  },
  {
    bgColor: "warning",
    icon: <CheckCircle />,
    title: "Helen Walter",
    para: "Well I am not sure.",
    time: "27 min.",
  },
];
